<template>
    <div>
        <div class="position-relative">
        <textarea
        ref="textarea"
        v-model="localValue"
        :id="inputId || null"
        :maxlength="maxLength > 0 ? maxLength : false"
        :style="{'resize': resize}"
        :rows="rows"
        :placeholder="placeholder"
        :required="required"
        :aria-required="required ? 'true' : null"
        :aria-describedby="describedBy || null"
        class="w-100 py-3 px-3 aup-input-textarea"
        :class="{ 'aup-input-textarea--error': error }"
        >
        </textarea>
        <label :for="inputId || null" class="aup-input-textarea__label aup-input-textarea__label--field-label t-heavy t-micro text-uppercase px-2" :class="{ 'aup-input-textarea__label--error': error }">error:call:5<span v-if="required" class="aup-input-textarea__required" aria-hidden="true"> *</span></label>
        <div class="aup-input-textarea__label aup-input-textarea__label--length t-heavy t-micro text-uppercase px-2" v-if="maxLength">error:call:6</div>
        </div>
        <p class="aup-input-error t-micro text-danger mt-1 mb-0 pl-3" v-if="error">error:call:7</p>
    </div>
</template>

<script>
    export default {
        name:"BaseTextArea",
        props: {
            label: {
                type: String,
                default: "Label"
            },
            maxLength: {
                type: Number,
                default: 0
            },
            resize: {
                type: String,
                default: "none"
            },
            rows: {
                type: Number,
                default: 8
            },
            value: {
                type: String,
                default: "",
                required: true
            },
            error: {
                type: String,
                default: "",
            },
            placeholder: {
                type: String,
                default: ""
            },
            required: {
                type: Boolean,
                default: false
            },
            // 'remaining' shows "72", 'total' shows "8 / 80"
            counterFormat: {
                type: String,
                default: 'remaining'
            },
            inputId: {
                type: String,
                default: ''
            },
            describedBy: {
                type: String,
                default: ''
            }
        },
        computed: {
            characterCount() {
                return this.localValue ? this.localValue.length : 0;
            },
            counterText() {
                return this.counterFormat === 'total'
                    ? `${this.characterCount} / ${this.maxLength}`
                    : this.maxLength - this.characterCount;
            }
        },
        watch: {
            value(val) {
                const next = val == null ? '' : String(val);
                if (next !== this.localValue) {
                    this.localValue = next;
                }
            },
            localValue() {
                this.$emit('input', this.localValue);
            }
        },
        data() {
            return {
                localValue: this.value == null ? '' : String(this.value)
            };
        },
        methods: {
            focus() {
                if (this.$refs.textarea) {
                    this.$refs.textarea.focus();
                }
            }
        }
    };
</script>

<style lang="scss">
    @import "../../assets/scss/all";
    .aup-input-textarea {

        &__label {
            position: absolute;
            background: $sony-white;
            &--field-label {
                top: 0;
                transform: translateY(-50%);
                left: 7px;
            }

            &--length {
                bottom: 0;
                transform: translateY(20%);
                right: 2%;
            }

            &--error {
                color: red;
            }
        }

        &__required {
            color: $primary;
        }

        &:focus {
            outline: none;
            box-shadow: 0 1px 0 $primary inset,
                        0 -1px 0 $primary inset,
                        -1px 0 0 $primary inset,
                        1px 0 0 $primary inset;
        }

        &--error {
            border-color: red;
        }
    }
</style>
